'use client'

import { usePathname } from 'next/navigation'
import NavBar from './NavBar'

export default function ConditionalHeader() {
  const pathname = usePathname()
  const isAuthPage = pathname?.startsWith('/login') || 
                     pathname?.startsWith('/register') || 
                     pathname?.startsWith('/fanbasis-register') || 
                     pathname?.startsWith('/forgot-password') ||
                     pathname?.startsWith('/reset-password')

  if (isAuthPage) {
    return null
  }

  return <NavBar />
}
